import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Trash2 } from "lucide-react";
import { CouponForm } from "@/components/admin/coupon-form";
import { adminCouponQuery, adminDeleteCoupon } from "@/lib/admin/coupons.functions";

export const Route = createFileRoute("/admin/cupons/$id")({
  loader: async ({ context, params }) => {
    const coupon = await context.queryClient.ensureQueryData(adminCouponQuery(params.id));
    if (!coupon) throw notFound();
    return coupon;
  },
  component: EditarCupomPage,
});

function EditarCupomPage() {
  const coupon = Route.useLoaderData();
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm(`Excluir o cupom "${coupon.code}" permanentemente?`)) return;
    setDeleting(true);
    await adminDeleteCoupon({ data: coupon.id });
    navigate({ to: "/admin/cupons" });
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-eg-dark">Editar Cupom</h1>
        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          className="inline-flex items-center gap-2 rounded-md border border-red-600 px-4 py-2 text-sm font-semibold text-red-600 hover:bg-red-600 hover:text-white disabled:opacity-60 transition-colors"
        >
          <Trash2 className="h-4 w-4" />
          Excluir
        </button>
      </div>
      <CouponForm coupon={coupon} />
    </div>
  );
}
